import React from 'react';
import PropTypes from 'prop-types';
import cls from 'classnames/bind';

import { LABEL_TYPES } from '../../constants';

import styles from './DealCard.scss';

const cx = cls.bind(styles);

class DealCard extends React.PureComponent {
  static propTypes = {
    loading: PropTypes.bool,
    href: PropTypes.string,
    defaultBackgroundImageUrl: PropTypes.string,
    backgroundImageUrl: PropTypes.string,

    leftTitle: PropTypes.node,
    leftSubTitle: PropTypes.node,
    leftPreTitle: PropTypes.node,

    rightTitle: PropTypes.node,
    rightSubTitle: PropTypes.node,
    rightPreTitle: PropTypes.node,

    label: PropTypes.string,
    labelType: PropTypes.oneOf(Object.values(LABEL_TYPES)),
    type: PropTypes.string,

    onClick: PropTypes.func,
    trackClick: PropTypes.func,

    openNewWindow: PropTypes.bool,
  };

  static defaultProps = {
    loading: false,
    // eslint-disable-next-line react/default-props-match-prop-types
    title: '',
    href: '',
    // eslint-disable-next-line react/default-props-match-prop-types
    price: 0,
    backgroundImageUrl: '',
    defaultBackgroundImageUrl: '',
    labelType: LABEL_TYPES.defaultProps,
    onClick: () => {},
    trackClick: () => {},
    openNewWindow: false,
  };

  handleClick = (event) => {
    const { onClick, trackClick, ...itemParams } = this.props;

    trackClick(event, itemParams);
    onClick(event, itemParams);
  };

  getContent() {
    const {
      loading,
      href,
      defaultBackgroundImageUrl,
      backgroundImageUrl,
      openNewWindow,

      type,
      labelType,
      label,

      leftPreTitle,
      leftTitle,
      leftSubTitle,

      rightPreTitle,
      rightTitle,
      rightSubTitle,
    } = this.props;

    if (loading) {
      return <div className={cx('containerLoading')} />;
    }

    return (
      <a
        className={cx('container')}
        onClick={this.handleClick}
        href={href}
        target={openNewWindow ? '_blank' : ''}
        data-locator="deal-card"
        rel="noreferrer"
      >
        <div
          className={cx('defaultBackground')}
          style={{ backgroundImage: `url("${defaultBackgroundImageUrl}")` }}
        />
        {!!backgroundImageUrl && (
          <div
            className={cx('background')}
            style={{ backgroundImage: `url("${backgroundImageUrl}")` }}
          />
        )}
        <div className={cx('hoverOverlay')} />
        <div className={cx('content')}>
          <div className={cx('header')}>
            {type && <div className={cx('type')}>{type}</div>}
            {label && <div className={cx('label', `label--${labelType}`)}>{label}</div>}
          </div>
          <div className={cx('footer')}>
            <div className={cx('leftContainer')}>
              {!!leftPreTitle && <div className={cx('leftPreTitle')}>{leftPreTitle}</div>}
              <div className={cx('leftTitle')} data-locator="deal-card-left-title">
                {leftTitle}
              </div>
              {!!leftSubTitle && <div className={cx('leftSubTitle')}>{leftSubTitle}</div>}
            </div>
            <div className={cx('rightContainer')}>
              {!!rightPreTitle && <div className={cx('rightPreTitle')}>{rightPreTitle}</div>}
              <div className={cx('rightTitle')}>{rightTitle}</div>
              {!!rightSubTitle && <div className={cx('rightSubTitle')}>{rightSubTitle}</div>}
            </div>
          </div>
        </div>
      </a>
    );
  }

  render() {
    const { className, product } = this.props;
    const content = this.getContent();

    return (
      <div className={cx('DealCard', className, { [`DealCard--${product}`]: !!product })}>
        {content}
      </div>
    );
  }
}

export default DealCard;
